



























import Vue, {PropType} from 'vue'

interface ICategory {
    children: any[]
    description: string
    directory: string
    discontinued: number
    id: number
    image: string
    name: string
    node_id: string
    order: number
    publish: null
    title: string
}

export default Vue.extend({
    name: "ServiceDownloadsProducts",
    props: {
        categories: {
            type: Array as PropType<Array<ICategory>>,
            required: true,
            default: () => []
        },
        activeCategory: {
            type: Object as PropType<ICategory>
        }
    },
    methods: {
        selectCategory(category: ICategory) {
            this.$emit("selectCategory", category);
        }
    },
    computed: {
        activeProducts(): ICategory[] {
            return this.categories.filter((category: ICategory) => {
                return !category.discontinued;
            })
        },
        inactiveProducts(): ICategory[] {
            return this.categories.filter((category: ICategory) => {
                return !!category.discontinued;
            })
        }
    }
})
